import { useHistory, useLocation } from 'react-router-dom';

interface NavigateToOptions {
    includeReturnUrl?: boolean;
}

export function useNavigation() {
    const history = useHistory();
    const location = useLocation();

    return {
        currentPath: location.pathname,
        navigateTo: (path: string, options: NavigateToOptions = {}) => {
            const pathParts = path.split('?');
            let search;

            if (options.includeReturnUrl) {
                const returnUrl = encodeURIComponent(location.pathname + location.search);
                search = pathParts[1] ? `${pathParts[1]}&returnUrl=${returnUrl}` : `returnUrl=${returnUrl}`;
            } else {
                search = pathParts[1]
            }

            history.push({
                pathname: pathParts[0],
                search
            });
        },
        navigateToReturnUrl: (fallbackUrl: string) => {
            const params = new URLSearchParams(location.search);
            const returnUrl = params.get('returnUrl') ?? fallbackUrl;
            history.push(returnUrl);
        }
    };
}
